export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        fontIcon: 'fal fa-tachometer-alt',
        addLinkClasses: 'c-dashboard-link'
        // badge: {
        //   color: 'primary',
        //   text: 'NEW'
        // }
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'SuperForm Updates',
        to: '/notifications',
        fontIcon: 'fal fa-bell'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Browse']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Customers',
        to: '/customers',
        fontIcon: 'fal fa-list',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Orders',
        to: '/orders/list',
        fontIcon: 'fal fa-list',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Estimates',
        to: '/estimates/list',
        fontIcon: 'fal fa-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Employees',
        to: '/employees/list',
        fontIcon: 'fal fa-list',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Documents']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Configuration',
        to: '/documents/configuration',
        fontIcon: 'fal fa-file-signature'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Customer Library',
        to: '/documents/manage',
        fontIcon: 'fal fa-folders'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Products',
        to: '/products/documents',
        fontIcon: 'fal fa-cubes'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Tools']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'FAQ',
        to: '/tools/faq',
        fontIcon: 'fal fa-question'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Instructions',
        to: '/instructions',
        fontIcon: 'fal fa-chalkboard-teacher'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Make Payment',
        to: '/tools/charge',
        fontIcon: 'fab fa-stripe'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Master Account',
        to: '/master-account',
        fontIcon: 'fal fa-user'
      }
    ]
  }
]
